import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { CSS_PROPERTY } from "../../features/Tablet/cssProperties/tablet"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { useHistory } from "react-router-dom"

const BackButton: React.FC<{
  addProc?: (e: React.TouchEvent<HTMLDivElement>) => unknown
}> = (prop) => {
  const history = useHistory()

  const onTouchStartEventHandler: React.TouchEventHandler<
    HTMLDivElement
  > = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    prop.addProc && (await prop.addProc(e))
    history.goBack()
  }

  return (
    <div
      onTouchStart={onTouchStartEventHandler}
      style={{
        backgroundColor: "white",
        display: "flex",
        width: "25rem",
        fontSize: "3rem",
        padding: "0.5rem 1rem",
        ...CSS_PROPERTY.BORER_PROPERTIES,
        marginBottom: "1rem",
      }}>
      <div>
        <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon>
      </div>
      <div
        style={{
          width: "100%",
          textAlign: "center",
        }}>
        <span>戻る</span>
      </div>
    </div>
  )
}

export default BackButton
